module.exports = __webpack_public_path__ + "img/Group-Five.0b3cc177.svg";